import React from 'react';

import {
  getResponsiveSearchAdPlacementStyles,
  getResponsiveSearchAdDesktopPlacementStyles,
  getResponsiveSearchAdMobilePlacementStyles,
} from '../../styles';
import { withUAPLThemedStyles } from '../../with-themed-styles';
import { bingDesktopHeaderImage } from '../media/bing-desktop-header';
import { ResponsiveSearchAdPlacementBase } from './responsive-search-ad-placement-base';

export const AdPlacementResponsiveSearch = withUAPLThemedStyles(

  (props: React.ComponentProps<typeof ResponsiveSearchAdPlacementBase>) => <ResponsiveSearchAdPlacementBase {...props} />,
  getResponsiveSearchAdPlacementStyles,
  { componentName: 'AdPlacementResponsiveSearch' }
);

export const AdPlacementResponsiveSearchDesktop = withUAPLThemedStyles(
  ({
    classes,
    i18n,
    ...props
  }: React.ComponentProps<typeof ResponsiveSearchAdPlacementBase>) => (
    <div className={classes.bingSearchDesktopPlacementRoot}>
      <div className="header-image">
        <img src={bingDesktopHeaderImage} alt={i18n.getString(_TL_('Header Image'))} />
      </div>
      <ResponsiveSearchAdPlacementBase {...props} classes={classes} i18n={i18n} />
    </div>
  ),
  getResponsiveSearchAdDesktopPlacementStyles,
  { componentName: 'AdPlacementResponsiveSearchDesktop' }
);

export const AdPlacementResponsiveSearchMobile = withUAPLThemedStyles(

  (props: React.ComponentProps<typeof ResponsiveSearchAdPlacementBase>) => (<div className={props.classes?.bingSearchMobilePlacementRoot}>
    <div className="bing-search-mobile-placement-parent">
      <ResponsiveSearchAdPlacementBase {...props} />
    </div>
                                                                            </div>),
  getResponsiveSearchAdMobilePlacementStyles,
  { componentName: 'AdPlacementResponsiveSearchMobile' }
);
